<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">
        {{ 'DIALOG.ASSIGN.LABEL' | translate }} {{ 'DIALOG.ASSIGN.STANDARD' | translate }}
      </h3>
    </div>
  </div>
  <div class="card-body">
    <form [formGroup]="form" class="form form-group mb-0">
      <mat-form-field appearance="fill" class="w-100 mb-5">
        <mat-label>{{ data.workflowGroup }} Workflow</mat-label>
        <mat-select
          required
          formControlName="workflowId"
          (selectionChange)="onWorkflowChange($event)"
        >
          <mat-option *ngFor="let workflow of data.workflows" [value]="workflow.id">{{
            workflow.name
          }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isInvalid('workflowId')">{{
          getErrorMessage(data.workflowGroup + ' Workflow')
        }}</mat-error>
      </mat-form-field>
      <div class="mb-5">
        <kt-general-autocomplete
          [label]="'Program'"
          [dataPath]="'data'"
          [loadItemsFunction]="getProgramAutocomplete"
          [optionFormatter]="formatProgramOption"
          [valueFormatter]="formatProgramOption"
          [control]="form.get('program')"
          [change]="onProgramChange.bind(this)"
          [required]="true"
          [readOnly]="false"
        ></kt-general-autocomplete>
      </div>
      <kt-general-autocomplete
        [label]="'Standards'"
        [loadItemsFunction]="getStandardAutocomplete"
        [optionFormatter]="formatStandardOption"
        [valueFormatter]="formatStandardOption"
        [formatNewObjectFn]="formatNewStandard"
        [control]="form.get('standards')"
        [objects]="form.get('standards').value"
        [change]="onStandardChange.bind(this)"
        [required]="false"
        [readOnly]="!form.get('program').value"
        [chipList]="true"
        [dataPath]="'data'"
      ></kt-general-autocomplete>
    </form>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      type="button"
      mat-raised-button
      cdkFocusInitial
      style="width: 75px"
      class="mr-4"
      (click)="onClose($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      type="button"
      mat-raised-button
      color="primary"
      style="width: 75px"
      [disabled]="form.invalid"
      (click)="onSubmit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
